<template>
  <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
    <v-dialog v-model="dialog_cashout" persistent width="500">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">{{ labeldialog }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closedialogcashout()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <br/>
          <p style="color: red;">
            cashout akan diproses dalam 2 hari kerja sesuai dengan ketentuan Penyedia Layanan Payment Gateway
          </p>
          <v-form ref="form" lazy-validation>
            <v-col cols="12" md="12 ">
              <v-select
                  label="Bank"
                  item-text="accountno"
                  return-object
                  v-model="cashoutrequest.bankdata"
                  :items="walletbanks"
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.bank }} - {{ data.item.accountno }} {{ data.item.accountname }}
                </template>
                <template slot="item" slot-scope="data">
                  {{ data.item.bank }} - {{ data.item.accountno }} {{ data.item.accountname }}
                </template>
              </v-select>
              <v-text-field label="Jumlah" name="name" v-model="cashoutrequest.amount"></v-text-field>
              <v-text-field label="OTP" name="otp" v-model="cashoutrequest.otp"></v-text-field>
              <v-btn @click="sendOtp" color="primary">
                <v-icon dark>send</v-icon>
                REQUEST OTP
              </v-btn>
            </v-col>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text dark @click="closedialogcashout" color="red">Tutup</v-btn>
          <v-btn text dark @click="ajukan" color="green">Ajukan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
      ></v-text-field>
      <v-spacer></v-spacer>
      <div class="mt-6">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitablecashout.awal"
                label="Tanggal Awal"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitablecashout.awal" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </div>
      <div class="mt-6">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitablecashout.akhir"
                label="Tanggal Akhir"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitablecashout.akhir" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </div>
      <v-btn class="ml-2" color="primary" @click.native="openformCashout">
        <v-icon dark>send</v-icon>
        Cashout
      </v-btn>
      <v-btn class="ml-2" color="primary" @click.native="getCashOut(opsitablecashout)">
        <v-icon dark>refresh</v-icon>
        Refresh
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
        :headers="headers"
        :search="search"
        :items="cashout"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitablecashout"
        :server-items-length="total_cashout"
        :loading="loading"
        @update:options="getCashOut(opsitablecashout)"
    >
      <template v-slot:item.amount="{ item }">
        <div class="">
          {{ formatAngka(item.amount) }}
        </div>
      </template>
      <template v-slot:item.createdat="{ item }">
        {{ formatDate(item.createdat) }}
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              v-if="item.status===1"
              color="green"
              small
              text-color="white"
          >{{ statusformat(item.status) }}
          </v-chip>
          <v-chip
              v-else-if="item.status===2"
              color="red"
              small
              text-color="white"
          >{{ statusformat(item.status) }}
          </v-chip>
          <v-chip
              v-else
              color="blue"
              small
              text-color="white"
          >{{ statusformat(item.status) }}
          </v-chip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import {mapActions, mapState} from "vuex";
import Utils from "@/plugins/utils";

export default {
  name: "Cashout",
  data: () => ({
    search: '',
    menu1: false,
    menu2: false,
    labeldialog: "Permintaan Pencairan Dana",
    dateawal: moment().add(7, 'hours').toISOString().substr(0, 10),
    dateakhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    opsitablecashout: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      sortBy: ["id"],
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    },
    cashoutrequest: {
      identity: '111',
      bank: 'MANDIRI',
      accountno: '',
      bankdata: {},
      accountname: '',
      amount: 0,
      otp: ''
    },
    headers: [
      {
        text: 'id',
        value: 'id'
      },
      {
        text: 'Time',
        value: 'createdat'
      },
      {
        text: 'Bank',
        value: 'bank'
      },
      {
        text: 'AccountNo',
        value: 'accountno'
      },
      {
        text: 'Account Holder',
        value: 'accountname'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Reff',
        value: 'reff'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Description',
        value: 'description'
      },

    ],
  }),
  computed: {
    ...mapState('Wallet', ['loading', 'dialog_cashout', 'cashout', 'total_cashout', 'walletbanks'])
  },
  methods: {
    ...mapActions('Wallet', ['getCashOut', 'docashout', 'opendialogcashout', 'closedialogcashout', 'getOtp']),
    ajukan() {
      this.cashoutrequest.bank = this.cashoutrequest.bankdata.bank
      this.cashoutrequest.accountno = this.cashoutrequest.bankdata.accountno
      this.cashoutrequest.accountname = this.cashoutrequest.bankdata.accountname
      const send = {...this.cashoutrequest}
      this.cashoutrequest.bank = ""
      this.cashoutrequest.accountno = ""
      this.cashoutrequest.accountname = ""
      this.docashout(send);
    },
    sendOtp() {
      this.getOtp("cash_out")
    },
    formatAngka(val) {
      return Utils.formatAngka(val)
    },
    openformCashout() {
      this.opendialogcashout()
    },
    formatDate(value) {
      return moment(value).add(7, 'hours').format("YYYY/MM/DD HH:mm:ss")
    },
    statusformat(value) {
      let a = 'Proses'
      if (value === 1) {
        a = 'Sukses'
      } else if (value === 2) {
        a = "Gagal"
      }
      return a
    },
  }
}
</script>

<style scoped>

</style>
